import React, { useContext, useState, useEffect } from 'react';
import { AppBar, Toolbar, Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { OrgContext } from '../contexts/OrgContext';
import AccountCircle from '@mui/icons-material/AccountCircle';
import profitizeLogo from '../assets/profitize_logo.png';
import { useNavigate } from 'react-router-dom';
import { getNotifications } from '../services/notificationService';
import { AuthContext } from '../contexts/AuthContext';
import GoogleImage from './GoogleImage';

const Header = () => {
  const { orgLogoURL, orgName } = useContext(OrgContext);
  const { user, isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  // We're keeping the notifications state for future use but not displaying them currently
  // eslint-disable-next-line no-unused-vars
  const [notifications, setNotifications] = useState([]);
  const [anchorUser, setAnchorUser] = useState(null);
  const [logoError, setLogoError] = useState(false);
  // Add local state to hold logo, initializing from context
  const [logo, setLogo] = useState(orgLogoURL);

  useEffect(() => {
    getNotifications().then((res) => {
      const sorted = sortNotifications(res);
      setNotifications(sorted);
    });
  }, []);

  useEffect(() => {
    if (isAuthenticated && user?.email) {
      localStorage.setItem('userEmail', user.email);
    }
  }, [isAuthenticated, user]);

  // Update local state when context value changes
  useEffect(() => {
    setLogo(orgLogoURL);
  }, [orgLogoURL]);

  // Listen for custom 'orgLogoUpdated' event to trigger state update
  useEffect(() => {
    const handler = () => {
      setLogo(localStorage.getItem('orgLogoURL'));
    };
    window.addEventListener('orgLogoUpdated', handler);
    return () => window.removeEventListener('orgLogoUpdated', handler);
  }, []);

  const storedEmail = localStorage.getItem('userEmail') || '';
  const storedPicture = localStorage.getItem('userPicture');

  const sortNotifications = (notifs) => {
    // Sort so new (isNew=true) are at the top
    return [...notifs].sort((a, b) => {
      // b.isNew - a.isNew will put true before false
      return (b.isNew === true) - (a.isNew === true);
    });
  };

  // Keep these methods for future use if notifications are re-enabled
  // eslint-disable-next-line no-unused-vars
  const markNotificationAsRead = (index) => {
    setNotifications((prev) => {
      const updated = [...prev];
      updated[index].isNew = false;
      return sortNotifications(updated);
    });
  };

  const handleUserMouseEnter = (event) => {
    setAnchorUser(event.currentTarget);
  };

  const handleUserMouseLeave = () => {
    setAnchorUser(null);
  };

  const handleLogout = () => {
    logout();
    localStorage.clear(); // Clear all localStorage instead of just email
    navigate('/auth');
  };

  const handleOrganizationsClick = () => {
    navigate('/list-orgs');
    handleUserMouseLeave();
  };

  const handleLogoError = () => {
    console.warn('Organization logo failed to load');
    setLogoError(true);
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      className="surface-header"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        height: '64px',
      }}
    >
      <Toolbar
        variant="dense"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '100%',
        }}
      >
        {/* Left Section: Org Logo and Name */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {logo && !logoError && (
            <img 
              src={logo} 
              alt="Organization Logo" 
              onError={handleLogoError}
              style={{
                maxHeight: '40px',
                maxWidth: '100px',
                height: 'auto',
                width: 'auto',
                marginRight: '16px'
              }}
            />
          )}
          {orgName && (
            <Typography variant="h6" sx={{ ml: 1 }}>
              {orgName}
            </Typography>
          )}
        </Box>

        {/* Center Section: Profitize IMS Logo */}
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
          <Box
            component="img"
            src={profitizeLogo}
            alt="Profitize IMS Logo"
            sx={{
              maxHeight: '40px',
              maxWidth: '150px',
              height: 'auto',
              width: 'auto',
            }}
          />
        </Box>

        {/* Right Section: Notifications and User Icon */}
        {isAuthenticated && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Notifications Icon */}
            {/* <IconButton
              color="inherit"
              onClick={handleNotifClick}
              sx={{ mr: 2, position: 'relative' }}
            >
              <Badge
                badgeContent={newNotificationsCount}
                color="error"
                overlap="circular"
                invisible={newNotificationsCount === 0}
              >
                <NotificationsIcon />
              </Badge>
            </IconButton> */}
            {/* <Menu
              anchorEl={anchorNotif}
              open={Boolean(anchorNotif)}
              onClose={handleNotifClose}
              PaperProps={{
                style: {
                  maxHeight: '50vh',
                  maxWidth: '350px',
                  backgroundColor: '#1e1e1e',
                  color: '#ffffff',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                },
              }}
            >
              {notifications.length === 0 && (
                <MenuItem disabled sx={{ fontSize: '0.75rem' }}>No Notifications</MenuItem>
              )}
              {notifications.map((notif, index) => {
                const isNew = notif.isNew;
                return (
                  <MenuItem
                    key={index}
                    onClick={() => handleNotificationClick(notif, index)}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      gap: '0.5rem',
                      fontSize: '0.75rem',
                      lineHeight: '1.2em',
                      backgroundColor: isNew ? '#262626' : 'inherit',
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    }}
                  > */}
                    {/* Left side: issue message with optional red dot */}
                    {/* <Box sx={{ display: 'flex', alignItems: 'flex-start', flex: '1 1 auto' }}>
                      {isNew && (
                        <Box
                          sx={{
                            height: '0.5em',
                            width: '0.5em',
                            borderRadius: '50%',
                            backgroundColor: '#FF0000',
                            display: 'inline-block',
                            mr: '0.5em',
                            mt: '0.2em'
                          }}
                        />
                      )}
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: isNew ? 'bold' : 'normal',
                          fontSize: '0.75rem',
                          lineHeight: '1.2em',
                          flex: '1 1 auto'
                        }}
                      >
                        {notif.issue}
                      </Typography>
                    </Box> */}

                    {/* Right side: ID text */}
                    {/* <Typography
                      variant="caption"
                      sx={{
                        display: 'block',
                        opacity: 0.8,
                        fontSize: '0.7rem',
                        flexShrink: 0,
                        textAlign: 'right'
                      }}
                    >
                      ID: {notif.id}
                    </Typography>
                  </MenuItem>
                );
              })}
            </Menu> */}

            {/* User Icon with hover menu */}
            <Box
              sx={{ position: 'relative' }}
              onMouseEnter={handleUserMouseEnter}
              onMouseLeave={handleUserMouseLeave}
            >
              <IconButton color="inherit">
                {(user?.picture || storedPicture) ? (
                  <GoogleImage 
                    url={user?.picture || storedPicture}
                    alt="User"
                    size={32}
                    fallbackIcon={<AccountCircle />}
                    sx={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                    }}
                  />
                ) : (
                  <AccountCircle />
                )}
              </IconButton>
              <Menu
                anchorEl={anchorUser}
                open={Boolean(anchorUser)}
                onClose={handleUserMouseLeave}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                  sx: {
                    bgcolor: 'background.paper',
                    border: '1px solid',
                    borderColor: 'divider',
                  },
                }}
              >
                <MenuItem disabled sx={{ fontSize: '0.75rem' }}>
                  {user?.email || storedEmail || 'No email'}
                </MenuItem>
                <MenuItem onClick={handleOrganizationsClick} sx={{ fontSize: '0.75rem' }}>
                  Organizations
                </MenuItem>
                <MenuItem onClick={handleLogout} sx={{ fontSize: '0.75rem' }}>
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
